import { BlogSection } from '@/types/blog';

export const introSection: BlogSection = {
  id: 'intro',
  title: 'Ein Impuls für wache Menschen in bewegten Zeiten',
  content: `
    <p class="lead text-lg text-joerg-600 mb-8">
      Ein Impuls für wache Menschen in bewegten Zeiten.
    </p>

    <p>
      Wir leben in einer Zeit, in der Worte schneller sind als Gedanken, Meinungen lauter als Beziehungen und Wahrheit oft weniger zählt als Reichweite. Was dabei verloren geht, ist unser gemeinsamer Raum als Gesellschaft – der Raum, in dem wir einander zuhören können, ohne sofort zu urteilen. Wir stehen an einem Punkt, an dem sich entscheidet, ob wir weiter von Emotionen getriggert werden oder ob wir eine neue Ethik der Kommunikation entwickeln, die unser digitales Zeitalter erst demokratiefähig macht.
    </p>
  `
};
